<template>
  <modal :title="label_name + ' (' + total_count + ' annotations2)'" @close_modal="close" :loading="panelLoading">
    <template v-slot:buttons>
      <v-btn
          v-if="hasImages"
          id="relabel-incorrect"
          @click="relabelSelectedAsIncorrect"
          :disabled="panelLoading || selectedCount === 0"
          color="error"
          variant="outlined"
          class="mr-2">
        {{$t('myboxes.btn_incorrect') || 'Incorrect'}}
      </v-btn>
      <v-btn
          v-if="hasImages"
          @click="validateSelectedCrops"
          :disabled="panelLoading || selectedCount === 0"
          color="primary">
        {{$t('myboxes.validate_selected') || 'Validate Selected'}}
      </v-btn>
    </template>
    <template v-slot:content>
      <label-crops-panel
          ref="panel"
          :label_name="label_name"
          :filters="filters"
          :total_count="total_count"
          :show-actions="false"
          @loaded="onPanelLoaded"
          @empty="onPanelLoaded"
          @selection-change="onSelectionChange"
          @loading-change="onLoadingChange"
      ></label-crops-panel>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import LabelCropsPanel from "@/components/LabelCropsPanel";

export default {
  name: "LabelCropsModal",
  components: {Modal, LabelCropsPanel},
  props: {
    label_name: {required: true},
    filters: {required: true},
    total_count: {required: true}
  },
  data() {
    return {
      hasImages: false,
      selectedCount: 0,
      panelLoading: false,
    };
  },
  methods: {
    onPanelLoaded(payload) {
      const panel = this.$refs.panel;
      this.hasImages = panel ? (panel.images || []).length > 0 : !!(payload && payload.count);
    },
    onSelectionChange(ids) {
      this.selectedCount = (ids || []).length;
    },
    onLoadingChange(loading) {
      this.panelLoading = !!loading;
    },
    validateSelectedCrops() {
      this.$refs.panel?.validateSelectedCrops?.();
    },
    relabelSelectedAsIncorrect() {
      this.$refs.panel?.relabelSelectedAsIncorrect?.();
    },
    close() {
      this.$emit('close_modal')
    },
  }
}
</script>
